import React from 'react';
import Box from '@mui/material/Grid';
import { pddServiceLine } from '../../../../utils/defaultValues';
import ProjectListHome from '../../../component-bundle/project-list/ProjectListHome';

const PddProjectListHome = () => {
  return (
    <Box
      style={{
        background: '#ffffff',
        height: '100%',
        padding: '10px',
        borderRadius: 4,
      }}
    >
      <ProjectListHome serviceLine={pddServiceLine} />
    </Box>
  );
};
export default PddProjectListHome;
